import { ComponentProps, ComponentType, FC, ReactNode } from 'react';

export const withManagers =
  (...managers: ComponentType<{ children: ReactNode }>[]) =>
  <T extends {}>(Component: FC<T>) => {
    type PropsType = ComponentProps<typeof Component>;

    const Provider = managers.reduce(
      (AccManager, NewManager) =>
        ({ children }) =>
          (
            <AccManager>
              <NewManager>{children}</NewManager>
            </AccManager>
          ),
    );
    const ResultComponent = (props: PropsType) => (
      <Provider>
        <Component {...props} />
      </Provider>
    );
    ResultComponent.displayName = `withManagers(${Component.displayName})`;
    return ResultComponent;
  };
